import type { SVGProps } from 'react'
const SvgSyTarget = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<circle cx={12} cy={12} r={3} />
		<path
			fillOpacity={0.24}
			fillRule="evenodd"
			d="M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12m0 1c1.717 0 3.29-.618 4.508-1.644l.018.018 1.414 1.414a.6.6 0 0 0 .848-.849l-1.414-1.414-.018-.017A6.97 6.97 0 0 0 19 12c0-1.717-.618-3.29-1.645-4.508l.02-.018 1.413-1.414a.6.6 0 0 0-.848-.849l-1.415 1.415-.018.019C15.29 5.619 13.717 5 12 5s-3.29.619-4.507 1.644l-.018-.018L6.06 5.21a.6.6 0 0 0-.848.849l1.414 1.414.019.018A6.97 6.97 0 0 0 5 12c0 1.717.618 3.29 1.644 4.508l-.018.017-1.414 1.414a.6.6 0 1 0 .848.849l1.415-1.414.017-.018A6.97 6.97 0 0 0 12 19"
			clipRule="evenodd"
		/>
	</svg>
)
export default SvgSyTarget
